import React from 'react';

const SectionDescription = ({ children }) => {
  return (
    <p className="text-xl text-center font-medium text-gray-600 mb-6">{children}</p>
  );
};

export default SectionDescription;
